import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header'
import Guidelinehero from './Guidelinehero'
import Guidelinetext from './Guidelinetext'

const Guideline = () => {
  return (
    <div>
        <Header />
        <Guidelinehero />
        <Guidelinetext />
        <Footer />
    </div>
  )
}

export default Guideline